<template>
    <div class="container">
        <vue-headful
                title="Ideas - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">All Ideas</h3>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">Idea ID</th>
                                <th scope="col">Idea Title</th>
                                <th scope="col">Idea Author</th>
                                <th scope="col">Idea Views</th>
                                <th scope="col">Idea Likes</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="idea in allIdeas" :key="idea.id">
                                <td>
                                    <button @click="deleteIdea(idea.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Idea"></button>
                                </td>
                                <th scope="row">
                                    {{idea.id}}
                                </th>
                                <td scope="row">
                                    <strong>{{idea.idea_title}}</strong>
                                </td>
                                <td>
                                    {{idea.user.username}}
                                </td>
                                <td>
                                    {{idea.idea_views}}
                                </td>
                                <td>
                                    {{idea.idea_likes}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      allIdeas: {}
    };
  },
  mounted() {
    this.getAllIdeas();
  },
  methods: {
    getAllIdeas() {
      axios({
        url:
          "admin/website/ideas?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.allIdeas = result.data.ideas;
            console.log(result);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteIdea(id) {
      axios({
        method: "delete",
        url: "admin/website/ideas/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Idea Deleted Successfully", "", "success");
            console.log(result);
            this.getAllIdeas();
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  }
};
</script>
<style>
</style>
